import React from 'react';
import { Link } from 'react-router-dom';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const DevelopmentPage = () => {
  return (
    <ContentLayout>
      <IBCard isCovered>
        <ul>
          <li>
            <Link to={`/theme`}>Theme</Link>
          </li>
          <li>
            <Link to={`/dashboard/development/orgSelector`}>
              Organization Selector
            </Link>
          </li>
        </ul>
      </IBCard>
    </ContentLayout>
  );
};

export default DevelopmentPage;
